//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as moment from 'moment-timezone'

export default {
  computed: {
    status() {
      return this.$auth.user.athlete.membershipStatus
    },
    statusColor() {
      const successColor = '#4fbd7e'
      const dangerColor = '#ec3062'

      return this.status && this.isActive ? successColor : dangerColor
    },
    isActive() {
      return this.status === 'active'
    },
    isNever() {
      return this.status === 'never'
    },
    isProvisional() {
      return this.$auth.user.athlete.provisionalPeriodStatus === 'enabled'
    },
    provisionalEndsAt() {
      return moment(this.$auth.user.athlete.provisionalPeriodEndsAt)
        .locale(this.$i18n.locale)
        .format('LL')
    },
    academyName() {
      return this.$auth.user.athlete.academy?.name || '-'
    },
    abbrAcademyName() {
      const maxChars = 20

      if (this.academyName.length > maxChars) return this.academyName.substring(0, maxChars) + '...'

      return this.academyName
    },
    hadApprovedMembership() {
      return this.$auth.user.athlete.membershipStatus !== 'never'
    }
  },
  methods: {
    goToProfile() {
      this.$router.push(this.localePath({ name: 'athletes-profile' }))
    },
    inactiveDialog() {
      if (!this.isActive) {
        this.$buefy.dialog.alert({
          message: this.$t('domain.athleteMembership.inactiveMessage')
        })
      }
    },
    provisionalDialog() {
      if (this.isProvisional) {
        this.$buefy.dialog.alert({
          message: this.$t('provisionalInfo', { date: this.provisionalEndsAt })
        })
      }
    }
  }
}
